/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { reserveAvailabilityResponseSchema } from "./reserveAvailabilityResponseSchema.ts";

export const orgUnitReserveAvailabilityRetrieveQueryDateSchema = z.iso.date();

export const orgUnitReserveAvailabilityRetrieveQueryDurationMinutesSchema = z.int().min(15).max(1440).optional();

export const orgUnitReserveAvailabilityRetrieveQueryGuestsCountSchema = z.int().min(1).max(100);

export const orgUnitReserveAvailabilityRetrievePathOrgUnitIdSchema = z.uuid();

export const orgUnitReserveAvailabilityRetrieveQueryReserveIdSchema = z
	.uuid()
	.optional()
	.describe("Бронь, которую гость переносит, её собственное время не считается занятым, иначе прежний стол был бы недоступным");

export const orgUnitReserveAvailabilityRetrieveStatus200Schema = reserveAvailabilityResponseSchema;

export const orgUnitReserveAvailabilityRetrieveResponseSchema = orgUnitReserveAvailabilityRetrieveStatus200Schema;
